import { selector } from "recoil";

import { DrawerType } from "../../models";
import { drawersAtom } from "../atoms/drawers";

export const isAddDropdownButtonVisibleSelector = selector({
  key: "isAddDropdownButtonVisibleSelector",
  get: ({ get }) => {
    const drawers = get(drawersAtom);
    const isTwoEditFormOpened =
      drawers.filter(
        ({ drawerProps: { type } }) => type === DrawerType.EditForm,
      ).length >= 2;

    return !isTwoEditFormOpened;
  },
});
